import { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';
import { IVehicleType, VehicleTypeAdd } from 'src/types/master_data/vehicleType.type';
import { PagedList } from 'src/types/pagedList.type';

const controller = 'hr/vehicle-types';

export const getVehicleTypes = async (page: number, pageSize: number, orderBy?: string, searchCondition?: string) => {
  return await http.get<PagedList<IVehicleType>>(controller, {
    params: {
      searchCondition,
      page,
      pageSize,
      orderBy
    }
  });
};

export const getVehicleType = async (id: number) => {
  return http.get<IVehicleType>(`${controller}/${id}`);
};

export const addVehicleType = async (vehicleType: VehicleTypeAdd) => {
  return http.post<IVehicleType>(controller, vehicleType);
};

export const updateVehicleType = async (id: number, vehicleType: IVehicleType) => {
  return await http.put<IVehicleType[]>(`${controller}/${id}`, vehicleType);
};

export const deleteVehicleType = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const getVehicleTypesDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};
